
import VideoEmbeds from './analytics/video-embeds.js';


if (! window.CollectiveShift) {
  window.CollectiveShift = {};
}

if (! window.CollectiveShift.Analytics) {
  window.CollectiveShift.Analytics = {};
}

VideoEmbeds();


export default window.CollectiveShift.Analytics;

